import { useQuery } from '@tanstack/react-query';
import React, { useContext, useState } from 'react';
import AddTaskForm from '../../components/AddTaskForm';
import UpdateForm from '../../components/UpdateForm';
import { AuthContext } from '../../context/AuthProvider/AuthProvider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faCircleCheck, faPen, faTrashCan, faCircleXmark
} from '@fortawesome/free-solid-svg-icons'
import { toast } from 'react-toastify';

const AddTask = () => {
    const [updateData, setUpdateData] = useState('')
    const { user } = useContext(AuthContext);
    const url = `${process.env.REACT_APP_API_URL}/my-tasks?email=${user?.email}`;
    const { data: tasks = [], isLoading, refetch } = useQuery({
        queryKey: ['my-tasks', user?.email],
        queryFn: async () => {
            const res = await fetch(url);
            const data = await res.json();
            return data.tasks;
        }
    })

    //handle mark the task as complete
    const handleCompleteTask = id => {
        console.log('mark as completed');
        fetch(`${process.env.REACT_APP_API_URL}/my-task/${id}`, {
            method: 'PATCH',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify({ status: true })
        })
            .then(res => res.json())
            .then(data => {
                // console.log(data);
                if (data.status) {
                    refetch();
                    toast.success(data.message);
                }

            })
    }
    //handle mark the task as complete
    const handleAvailableTask = id => {
        console.log('mark as uncompleted');
        fetch(`${process.env.REACT_APP_API_URL}/my-task/${id}`, {
            method: 'PATCH',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify({ status: false })
        })
            .then(res => res.json())
            .then(data => {
                // console.log(data);
                if (data.status) {
                    refetch();
                    toast.success(data.message);
                }

            })
    }

    // remove the task
    const handleTaskDelete = id => {
        fetch(`${process.env.REACT_APP_API_URL}/my-task/${id}`, {
            method: "DELETE"
        })
            .then(res => res.json())
            .then(data => {
                // console.log(data);
                if (data.status) {
                    refetch();
                    toast.success(data.message);
                }
            })
    }

    // Cancel update
    const cancelUpdate = () => {
        setUpdateData('')
    }

    return (
        <div className="max-w-5xl mx-auto py-16">
            <h2 className='text-center text-3xl font-bold'>ADD YOUR NEW TASK!</h2>
            <br /><br />

            {updateData && updateData ? (
                <UpdateForm
                    updateData={updateData}
                    cancelUpdate={cancelUpdate}
                    refetch={refetch}
                    isLoading={isLoading}
                />
            ) : (
                <AddTaskForm
                    refetch={refetch}
                    isLoading={isLoading}
                />
            )}

            <div className='mt-3'>
                {tasks && tasks.length ? <>
                    {
                        tasks?.map((task, index) =>
                            <div key={task._id} className="col taskBg">
                                <div className={task.isTaskCompleted ? 'done' : ''}>
                                    <span className="taskNumber">{index + 1}</span>
                                    <span className="taskText">{task.taskName}</span>
                                </div>
                                <div className="iconsWrap">
                                    {
                                        task.isTaskCompleted ?
                                            <span title="Mark as not completed"
                                                onClick={() => handleAvailableTask(task._id)}>
                                                <FontAwesomeIcon icon={faCircleXmark} />
                                            </span> :
                                            <span className='text-red-800' title="Mark as Completed"
                                                onClick={() => handleCompleteTask(task._id)}><FontAwesomeIcon icon={faCircleCheck} /></span>
                                    }




                                    {task.isTaskCompleted ? null : (
                                        <span title="Edit"
                                            onClick={() => setUpdateData(task)}
                                        >
                                            <FontAwesomeIcon icon={faPen} />
                                        </span>
                                    )}

                                    <span title="Delete"
                                        onClick={() => handleTaskDelete(task._id)}
                                    >
                                        <FontAwesomeIcon icon={faTrashCan} />
                                    </span>
                                </div>
                            </div>
                        )
                    }
                </> : <p className='text-center'>You didn't create any tasks yet...</p>}
            </div>


        </div>
    );
};

export default AddTask;